document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('create_customer');

  if (form) {
    form.addEventListener('submit', function(event) {
      console.log("Before submit");

      var passwordInput = document.getElementById('RegisterForm-password');
      var passwordValue = passwordInput.value;

      if (passwordValue.length < 8) {
        console.log("incorrect password");
        alert("Password must be at least 8 characters.");

        var passwordError = document.getElementById('RegisterForm-password-error');
        if (passwordError) {
          passwordError.innerHTML = 'Password must be at least 8 characters.';
        }

        event.preventDefault();
        return false;
      }

      console.log("Password is valid");
    });
  }
});
